import React from "react";
import { t } from "@lingui/macro";
// Our modules
import { QuickLinks, Section } from "../../../components";
import { i18n } from "idc-ui-react";

const QuickLinksList = ({ links }) => {
  if (!links) return null;

  return links.quickLinks ? (
    <Section text={i18n._(t`Quick links`)} slide="right">
      <QuickLinks links={links.quickLinks} />
    </Section>
  ) : null;
};

export default QuickLinksList;
